import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import CampCard from "../campCard";
import NotFoundCamp from "../notFoundCamp";
import { CardProps } from "../../../utils/types";

const CustomCard = ({ count, cardData, selectedCity, selectedCategory, categoryWiseDataNotFound, setPageNumber, nonProfitLoader }: CardProps) => {
    const donationCampData = categoryWiseDataNotFound
        ? cardData?.slice(0, 3)
        : cardData;
    return (
        <>
            {categoryWiseDataNotFound &&
                <NotFoundCamp selectedCity={selectedCity} selectedCategory={selectedCategory} />
            }
            <CampCard count={count} donationCampData={donationCampData} setPageNumber={setPageNumber} nonProfitLoader={nonProfitLoader} />
        </>
    )
};
export default CustomCard;